// extracted by mini-css-extract-plugin
export var infoRow = "_po-2";
export var labelContainer = "_po-0";
export var rightInfo = "_po-1";